import { useIntl } from 'react-intl';
import { checkUserResourcePermissions } from 'sonata-static-storage/lib/helpers/user.helpers';
import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';

import { useGlobalStore } from '@/store/global';
import { getUser } from '@/store/global/user/selectors';
import { getUserRoles } from '@/store/global/userRoles/selectors';
import { CheckboxGroup, type CheckboxItem } from '../CheckboxGroup';

type FilterEntry = { id: string; value: string[] };

type Props = {
  onFilter?: (filters: FilterEntry[]) => void;
  value?: string[];
};

export default function MediaChannel({ onFilter, value = [] }: Props) {
  const { formatMessage } = useIntl();
  const user = useGlobalStore(getUser);
  const userRoles = useGlobalStore(getUserRoles);

  const allOptions: CheckboxItem[] = [
    {
      id: CampaignFamilyEnum.standard,
      label: formatMessage({
        defaultMessage: 'Digital',
        id: 'campaigns.lineItems.advancedFilters.mediaChannel.digital'
      })
    },
    {
      id: CampaignFamilyEnum.dooh,
      label: formatMessage({
        defaultMessage: 'DOOH',
        id: 'campaigns.lineItems.advancedFilters.mediaChannel.dooh'
      }),
      show: checkUserResourcePermissions('campaignType', user.toJSON(), userRoles)
    },
    {
      id: CampaignFamilyEnum.ctv,
      label: formatMessage({
        defaultMessage: 'CTV',
        id: 'campaigns.lineItems.advancedFilters.mediaChannel.ctv'
      }),
      show: checkUserResourcePermissions('ctvDevicePlatform', user.toJSON(), userRoles)
    }
  ];

  const handleChange = (_id: string, selected: string[]) => {
    const filter: FilterEntry[] = [{ id: 'mediaChannel', value: selected }];
    onFilter?.(filter);
  };

  return (
    <CheckboxGroup
      id="mediaChannel"
      onChange={handleChange}
      options={allOptions}
      selected={value}
      title={formatMessage({
        defaultMessage: 'Media Channel',
        id: 'campaigns.lineItems.advancedFilters.mediaChannel.title'
      })}
    />
  );
}
